export default __webpack_public_path__ + "static/media/preview.a483955b.png";